import { useLingui } from '@lingui/react';
import styled from 'styled-components';
import { WrapperItem } from '~/components/ui/wrapper-item';
import Modal from '~/components/ui/modal';
import Button from '~/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { SPText } from '~/components/styles/styles';

interface IProps {
  open: boolean;
  onClose: () => void;
}
type TProps = IProps;

export default function QuitDialog({ open, onClose }: TProps) {
  const { i18n } = useLingui();
  const navigate = useNavigate();

  return (
    <Modal
      heightPortrait="90%"
      heightLandscape="70%"
      widthPortrait="95%"
      widthLandscape="60%"
      onClose={onClose}
      open={open}
    >
      <Container>
        <WrapperItem setMaxHeight widthPortrait="100%" widthLandscape="100%">
          <ContentWrapper>
            <SPText $textAlign="center">
              {i18n._('common.quit.solo.text')}
            </SPText>

            <SDivBtn className={open ? 'open' : 'closed'}>
              {open && (
                <>
                  <Button
                    type={'button'}
                    color="primary"
                    disabled={!open}
                    onClick={() => navigate('/home')}
                    margin="20px 0 0 0"
                  >
                    {i18n._('common.quit.solo')}
                  </Button>
                  <Button
                    type={'button'}
                    color="secondary"
                    disabled={!open}
                    onClick={onClose}
                    margin="20px 0 0 0"
                    width="auto"
                  >
                    {i18n._('common.game.continue')}
                  </Button>
                </>
              )}
            </SDivBtn>
          </ContentWrapper>
        </WrapperItem>
      </Container>
    </Modal>
  );
}

const ContentWrapper = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

const SDivBtn = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: auto;
  & > button:last-of-type {
    margin-left: 20px;
  }
`;

const Container = styled.div`
  padding: 5px;
  width: 100%;
`;
